import { useSearchParams } from 'react-router-dom';
import { SessionsTab as B2BSessionsTab } from '@/routes/formation-b2b/SessionsTab';
import { FacturesTab as B2BFacturesTab } from '@/routes/formation-b2b/FacturesTab';
import { DettesTab as B2BDettesTab } from '@/routes/formation-b2b/DettesTab';
import { RoiTab as B2BRoiTab } from '@/routes/formation-b2b/RoiTab';
import { InterTab as B2BInterTab } from '@/routes/formation-b2b/InterTab';
import { B2cDashboardPage } from '@/routes/formation-b2c/B2cDashboardPage';
import { B2cRoiTab } from '@/routes/formation-b2c/RoiTab';
import { B2cInterTab } from '@/routes/formation-b2c/InterTab';

/**
 * Page Formation unifiée — dispatch vers l'onglet B2B ou B2C selon
 * les search params ?segment=b2b|b2c et ?tab=sessions|factures|dettes|roi|inter.
 *
 * La barre d'onglets est rendue par FormationUnifiedLayout (parent).
 */
export function FormationPage(): JSX.Element {
  const [params] = useSearchParams();
  const segment = params.get('segment') === 'b2c' ? 'b2c' : 'b2b';
  const tab = params.get('tab') ?? 'sessions';

  if (segment === 'b2c') {
    if (tab === 'roi') return <B2cRoiTab />;
    if (tab === 'inter') return <B2cInterTab />;
    return <B2cDashboardPage />;
  }

  // B2B
  if (tab === 'factures') return <B2BFacturesTab />;
  if (tab === 'dettes') return <B2BDettesTab />;
  if (tab === 'roi') return <B2BRoiTab />;
  if (tab === 'inter') return <B2BInterTab />;
  return <B2BSessionsTab />;
}
